<template>
  <div class="pc-lecture-model">
    <h2>模型管理</h2>
    <El-button v-if="!isEditting" @click="edit()" class="edit-btn"
      >编辑</El-button
    >
    <El-button v-if="isEditting" @click="edit()" class="edit-btn"
      >完成</El-button
    >

    <ul class="pc-lecture-model-list">
      <li class="model-item" v-for="(item, index) in ModelList" :key="index">
        <div class="model-item-left">
          <img
            src="../../../../../static/loading.gif"
            v-if="item.isUploadingModel"
            alt=""
          />
          <div class="icon" v-if="item.src && !item.isUploadingModel">
            <p class="el-icon-circle-check"></p>
            <p class="hint" @click="showModel(item)">模型已上传,点击查看</p>
          </div>
          <div class="icon" v-if="!item.src && !item.isUploadingModel">
            <p class="el-icon-warning-outline icon"></p>
            <p class="hint">暂无模型</p>
          </div>

          <p class="title">模型纹理图</p>
          <div class="texture-list" v-if="!item.isEdittingModel">
            <div
              class="texture-img"
              v-for="texture in item.texture"
              :key="texture.id"
            >
              <img :src="texture" alt="" />
            </div>
          </div>

          <UploadTexture
            ref="uploadTexture"
            v-if="item.isEdittingModel && isEditting"
            :isEditting="item.isEdittingModel && isEditting"
            :model="selectedModel"
            @getTextures="getUploadModeltexture($event, item, index)"
            class="upload-texture"
          ></UploadTexture>
        </div>
        <div class="model-item-right">
          <div class="model-content">
            <div class="model-image">
              <img
                v-if="!item.isEdittingModel && item.icon"
                :src="item.icon"
                alt=""
              />
              <img
                v-if="!item.isEdittingModel && !item.icon"
                src="../../../../../static/image/no-img.png"
                alt=""
              />

              <UploadImage
                v-show="item.isEdittingModel && isEditting"
                :img="item.icon"
                :width="80"
                :height="80"
                @getUploadImage="getUploadModelIcon($event, item, index)"
                class="upload-image"
              ></UploadImage>
              <p>Icon</p>
              <img
                v-if="!item.isEdittingModel && item.click_icon"
                :src="item.click_icon"
                alt=""
              />
              <img
                v-if="!item.isEdittingModel && !item.click_icon"
                src="../../../../../static/image/no-img.png"
                alt=""
              />

              <UploadImage
                v-if="item.isEdittingModel && isEditting"
                :img="item.click_icon"
                :width="80"
                :height="80"
                @getUploadImage="getUploadModelIconChecked($event, item, index)"
                class="upload-image"
              ></UploadImage>

              <p>IconChecked</p>
            </div>
            <div class="model-introduction">
              <div class="title">
                <h4>标题</h4>
                <span v-if="!item.isEdittingModel">{{ item.title }}</span>
                <el-input
                  v-if="item.isEdittingModel && isEditting"
                  v-model="item.title"
                  placeholder="视频文件名称"
                ></el-input>
              </div>
              <div class="description">
                <h4>介绍</h4>
                <span v-if="!item.isEdittingModel">{{ item.introduce }}</span>
                <el-input
                  type="textarea"
                  rows="6"
                  v-if="item.isEdittingModel && isEditting"
                  v-model="item.introduce"
                  placeholder="模型简介"
                ></el-input>
              </div>
              <div class="order">
                <h4>Order</h4>
                <span v-if="!item.isEdittingModel">{{ item.order }}</span>
                <el-input-number
                  v-if="item.isEdittingModel && isEditting"
                  v-model="item.order"
                  size="small"
                  :min="1"
                  placeholder="模型顺序"
                ></el-input-number>
                <span class="hint" v-if="item.isEdittingModel && isEditting"
                  >*最上方的模型为1</span
                >
              </div>
            </div>
          </div>
          <div class="model-caption">
            <span class="el-icon-warning-outline" v-if="!item.voice_exists"
              >*该模型暂无语音</span
            >
            <div class="update">
              <p
                v-if="item.isEdittingModel && isEditting"
                @click="createVoice(item)"
              >
                生成语音
              </p>
              <p @click="viewVoice(item)" v-if="item.voice_exists">查看语音</p>
              <p
                v-if="!item.isEdittingModel && isEditting"
                @click="editModel(index, item)"
              >
                修改
              </p>
              <UploadModel
                v-if="item.isEdittingModel && isEditting"
                @getUploadModel="getUploadModel($event, item)"
                @startUploadModel="startUploadModel(item, index)"
                @endUploadModel="endUploadModel(item, index)"
              ></UploadModel>

              <p
                v-if="item.isEdittingModel && isEditting"
                @click="deleteShow(index)"
              >
                删除
              </p>
              <p
                v-if="item.isEdittingModel && isEditting"
                @click="changeModel(item)"
              >
                确认
              </p>
            </div>
          </div>
        </div>
      </li>
    </ul>
    <div @click="addModel()" class="add-btn" v-show="isEditting">
      <span>添加</span>
    </div>
    <DeleteDialog
      :dialogVisible="deleteDialogVisible"
      @isCancel="closeDelete"
      @isDelete="deleteConfirm"
    />
    <ModelShow
      v-if="modelDialogVisible"
      :model="selectedModel"
      :dialogVisible="modelDialogVisible"
      @handleClose="modelDialogVisible = false"
    />
    <VoiceShow
      v-if="voiceDialogVisible"
      :title="selectedModel.title"
      :voice_list="modelVoiceList"
      :dialogVisible="voiceDialogVisible"
      @handleClose="voiceDialogVisible = false"
    />
    <div class="voiceHint" v-show="voiceHintVisible">
      <!-- 中间提示框 -->
      <div class="voiceHint-prompt">
        <span>生成语音中,请不要点击其他地方....</span>
      </div>
    </div>
  </div>
</template>

<script>
import ModelShow from "./ModelShow";
import DeleteDialog from "../../../componentSet/DeleteDialog";
import UploadModel from "./UploadModel.vue";
import UploadImage from "../../../componentSet/uploadImage.vue";
import UploadTexture from "./UploadTexture";
import VoiceShow from "./VoiceShow";

import {
  getHeritageModel_Api,
  updateHeritageModel_Api,
  createHeritageModel_Api,
  deleteHeritageModel_Api,
  createHeritageModelVoice_Api,
  getHeritageModelVoice_Api,
} from "../../../../apis/heritage.api";
export default {
  data() {
    return {
      isEditting: false,
      deleteDialogVisible: false,
      modelDialogVisible: false,
      voiceHintVisible: false,
      voiceDialogVisible: false,
      modelVoiceList: [],
      ModelList: [],
      lecture_id: null,
      delete_index: null,
      selectedModel: null,
    };
  },
  mounted() {
    if (this.$route.query.method == "update") {
      this.lecture_id = this.$route.query.id;
      this.getHeritageModel();
    }
  },
  components: {
    VoiceShow,
    ModelShow,
    UploadModel,
    UploadImage,
    DeleteDialog,
    UploadTexture,
  },
  methods: {
    showModel(item) {
      this.selectedModel = item;
      this.modelDialogVisible = true;
    },
    createVoice(item) {
      this.voiceHintVisible = true;
      createHeritageModelVoice_Api({
        model_id: item.id,
        text: item.introduce,
      }).then((res) => {
        if (res.code == "205") {
          this.$global.success(this, "生成语音成功");
          this.voiceHintVisible = false;
        } else {
          this.$global.error(this, "生成语音失败");
        }
      });
    },
    viewVoice(item) {
      this.selectedModel = item;
      if (!item.voice_exists) {
        this.$global.error(this, "该模型下没有合成的语音");
        return;
      }
      getHeritageModelVoice_Api(item.id).then((res) => {
        if (res.code == "205") {
          let mapping = {
            1: "标准男声",
            2: "温柔女声",
            3: "儿童音",
            4: "儿童音",
            5: "萝莉女声",
            6: "英文男声",
            7: "英文女声",
            8: "粤语女声",
          };
          res.data.forEach((item) => {
            item.name = mapping[item.voice_type];
          });
          this.modelVoiceList = res.data;
          this.voiceDialogVisible = true;
        } else {
          this.$global.error(this, "该模型下没有合成的语音");
        }
      });
      console.log(item);
    },
    async edit() {
      this.isEditting = !this.isEditting;
      if (!this.isEditting) {
        this.ModelList.forEach((item) => {
          item.isEdittingModel = false;
        });
        await this.getHeritageModel();
        this.$global.success(this, "获取成功");
      }
    },
    addModel() {
      let item = {
        method: "add",
        isEdittingModel: true,
        src: null,
        model: "",
        icon: null,
        click_icon: null,
        title: "",
        introduce: "",
        order: 1,
        texture: [],
      };

      this.ModelList.push(item);
      this.selectedModel = item;
    },
    getUploadModeltexture(data, item, index) {
      console.log(data, item, index);
      item.texture = data.map((item) => item.url);
      this.$set(this.ModelList, index, item);
    },
    getUploadModelIcon(data, item, index) {
      item.icon = data;
      this.$set(this.ModelList, index, item);
    },
    getUploadModelIconChecked(data, item, index) {
      item.click_icon = data;
      this.$set(this.ModelList, index, item);
    },
    startUploadModel(item, index) {
      item.isUploadingModel = true;
      this.$set(this.ModelList, index, item);
    },
    getUploadModel(data, item, index) {
      console.log(data);
      item.isUploadingModel = false;
      item.src = data;
      this.selectedModel = item;
      // this.$refs["uploadTexture"].getModelSrc(item.src);
      this.$set(this.ModelList, index, item);

      console.log(item, data);
    },
    endUploadModel(item, index) {
      item.isUploadingModel = true;
      this.$set(this.ModelList, index, item);
    },
    editModel(index, item) {
      this.selectedModel = item;
      console.log(item);
      item.isEdittingModel = true;
      this.$set(this.ModelList, index, item);
    },
    getHeritageModel() {
      getHeritageModel_Api(this.lecture_id).then((res) => {
        res.data.sort((a, b) => {
          if (!b.order) {
            b.order = 10;
          }
          if (!a.order) {
            a.order = 10;
          }
          return -b.order + a.order;
        });
        this.ModelList = res.data;
        this.ModelList.forEach((item) => {
          item.method = "update";
          item.isEdittingModel = false;
          item.isUploadingModel = false;
        });

        console.log(this.ModelList);
      });
    },
    deleteConfirm() {
      console.log(this.ModelList[this.delete_index]);
      // this.
      let model_id = this.ModelList[this.delete_index].id;
      if (model_id) {
        deleteHeritageModel_Api({ model_id: model_id })
          .then((res) => {
            if (res.code == "205") {
              this.$global.success(this, "删除成功");
            } else {
              this.$global.error(this, "删除失败");
            }
            this.getHeritageModel();
            this.deleteDialogVisible = false;
          })
          .catch(() => {
            this.$global.error(this, "删除失败, 请重试");
          });
      } else {
        this.ModelList.splice(this.delete_index, 1);
        this.deleteDialogVisible = false;
      }
    },
    closeDelete() {
      console.log(1324132);
      this.deleteDialogVisible = false;
    },
    deleteShow(index) {
      this.delete_index = index;
      this.deleteDialogVisible = true;
    },
    changeModel(item) {
      console.log(item);

      if (item.id) {
        item.model_id = item.id;
      }
      item.heritage_id = this.$route.query.id;
      item.texture_list = item.texture;
      if (item.method == "update") {
        updateHeritageModel_Api(item)
          .then((res) => {
            this.getHeritageModel();
            console.log(res);
            this.$global.success(this, "更新成功");
          })
          .catch(() => {
            this.$global.error(this, "更新失败");
          });
      } else {
        item.lecture_id = this.$route.query.id;
        createHeritageModel_Api(item)
          .then((res) => {
            this.getHeritageModel();
            console.log(res);
            this.$global.success(this, "添加成功");
            // item.isEdittingModel = false;
            // item.isUploadingModel = false;
          })
          .catch(() => {
            this.$global.error(this, "添加失败");
          });
      }

      console.log(item);
    },
  },
};
</script>

<style scoped lang='scss'>
.pc-lecture-model {
  @include box-model;
  .edit-btn {
    right: 30px;
  }
  .pc-lecture-model-list {
    width: 100%;
    .model-item {
      display: flex;
      width: 100%;
      margin-bottom: 20px;
      padding-bottom: 20px;
      border-bottom: 1px $timeBtn dashed;
      .model-item-left {
        position: relative;
        width: 285px !important;
        // height: 160px;
        margin-right: 20px;

        img {
          width: 285px;
          height: 160px;
        }
        .texture-list {
          display: flex;
          flex-wrap: wrap;
          .texture-img {
            margin-right: 5px;
            img {
              width: 50px;
              height: 50px;
              object-fit: cover;
            }
          }
        }
        .icon {
          // border: 1px solid #979797;
          width: 285px;
          height: 160px;
          line-height: 160px;
          font-size: 100px;
          text-align: center;
          .el-icon-circle-check {
            color: #67c23a;
          }
          .el-icon-warning-outline {
            color: $lightenYellow;
          }

          .hint {
            cursor: pointer;
            line-height: 10px;
            margin-top: -28px;
            font-size: 10px;
          }
        }

        .title {
          font-size: 10px;
          font-weight: 200;
        }
        .upload-texture {
          margin-top: 2px;
        }
      }
      .model-item-right {
        width: calc(100% - 285px);
        position: relative;
        .model-content {
          display: flex;
          .model-image {
            p {
              width: 80px;
              font-size: 12px;
              font-weight: 200;
            }
            img {
              width: 60px;
              height: 60px;
              object-fit: cover;
            }
            .upload-image {
              margin-right: 25px;
              margin-bottom: 5px;
              /deep/ .el-upload__tip {
                display: none;
              }
              /deep/ .el-icon-upload {
                display: none;
              }
            }
          }
          .model-introduction {
            width: 100%;

            .title,
            .description,
            .order {
              display: flex;
              margin-bottom: 20px;
              h4 {
                flex-shrink: 0;
                font-size: 14px;
                width: 50px;
                font-weight: 600;
                text-align: right;
                margin-right: 20px;

                align-self: center;
                display: flex;
                justify-content: flex-end;
              }
              span {
                font-size: 12px;
                // line-height: 32px;
              }
            }
            .order {
              margin-bottom: 0px;
              .hint {
                line-height: 32px;
                font-size: 10px;
                margin-left: 10px;
              }
              .el-icon-warning-outline {
                margin-left: 10px;
                color: $lightenYellow;
              }
            }
          }
        }
        .model-caption {
          margin-top: 80px;
          position: relative;
          display: flex;
          font-size: 12px;
          align-items: flex-start;
          .el-icon-warning-outline {
            position: absolute;
            right: 0px;
            top: -20px;
            color: $lightenYellow;
          }
          .caption {
            width: 220px;
            font-size: 12px;
            margin-right: 20px;
          }
          .process {
            display: flex;
            width: 400px;
            .process-bar {
              width: 300px;
            }
          }
          .update {
            line-height: 20px;
            text-align: center;
            border-radius: 5px;
            cursor: pointer;
            display: flex;
            margin-left: auto;
            background: $base-color;
            p {
              border: 1px $timeBtn dashed;
              width: 60px;
              height: 20px;
              color: $timeBtn;
              margin-left: 10px;
            }
            p:hover {
              background: $timeBtn;
              color: $base-color;
            }
          }
        }
      }

      .model-item-bottom {
        font-size: 14px;
        width: 80%;
        min-width: 700px;
        color: #434343;
        line-height: 21px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        h4 {
          font-size: 14px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #434343;
          line-height: 21px;
        }
        /deep/ .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
          background-color: #409eff;
          border-color: #409eff;
        }
        /deep/
          .el-checkbox__input.is-disabled.is-checked
          .el-checkbox__inner::after {
          border-color: #fff;
        }
        /deep/ .el-checkbox__input.is-checked + .el-checkbox__label {
          color: #000;
        }
        /deep/ .el-input__inner {
          width: 90%;
          height: 40px;
          border-radius: 4px;
          border: 1px solid #dcdfe6;
        }
        /deep/ .el-input:first-of-type {
          margin-top: 0px;
        }
        /deep/ .el-input {
          margin-bottom: 10px;
        }
        textarea {
          width: 90%;
          height: 60px;
          border-radius: 4px;
          border: 1px solid #dcdfe6;
          padding-left: 15px;
          outline-color: #dcdfe6;
          resize: none;
        }
        /deep/ input:-ms-input-placeholder,
        /deep/ textarea:-ms-input-placeholder {
          color: #999999;
        }
        /deep/ input::-webkit-input-placeholder,
        /deep/ textarea::-webkit-input-placeholder {
          color: #999999;
        }
        p {
          margin-top: 10px;
          width: 1200px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #434343;
          line-height: 21px;
        }
        .pc-model-content-bottom-subtitle {
          display: flex;
          span {
            display: inline-block;
            width: 100px;
            height: 26px;
            background: #ffffff;
            border-radius: 4px 4px 4px 4px;
            border: 1px solid #dcdfe6;
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-right: 30px;
            // text-align: center;
            strong {
              // width: 48px;
              margin-left: 11px;
              font-size: 12px;
              // font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #5470c6;
              line-height: 12px;
              text-align: left;
            }
            i {
              display: inline-block;
              margin-top: -1px;
              // margin-right: -16px;
              // margin-left: 11px;
              width: 19px;
              height: 26px;
              background: #dcdfe6;
              border-radius: 4px;
              border: 1px solid #dcdfe6;
              color: #5470c6;
              text-align: right;
            }

            /deep/ .icon-zhuanhuan:before {
              font-size: 10px;
            }
            /deep/ .icon-shangchuanicon:before {
              font-size: 10px;
            }
          }
          /deep/ .el-upload--text {
            width: 100px;
            display: flex;
            justify-content: space-between;
            i {
              margin-top: 0;
              border-radius: 0 4px 4px 0 !important;
              display: inline-block;
              text-align: center;
            }
          }
          /deep/ .el-button--mini {
            // border-radius: 4px 0 0 4px !important;
            border: none;
            margin-left: 11px;
            margin-top: 1px;

            height: 24px;
            padding: 0;
            text-align: center;
            line-height: 26px;
          }
          /deep/ .el-button--primary {
            background-color: #fff;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #646464;
            font-size: 12px;
          }
        }
      }
      .model-item-position {
        width: 40px;
        height: 100px;
        text-align: center;
        background: #ffffff;
        box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
        border-radius: 20px;
        display: none;
        p {
          margin-bottom: 10px;
        }
        .pc-model-position-top {
          margin-top: 15px;
          // margin-bottom: 21px;
        }
      }
    }
  }
  .add-btn {
    width: 110px;
    height: 40px;
    margin-top: 40px;
    margin-bottom: 40px;
    cursor: pointer;
    text-align: center;
    line-height: 40px;
    border: 1px #5470c6 dashed;
    span {
      font-size: 14px;
      text-align: center;
      color: #5470c6;
    }
  }
  .voiceHint {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 9999;
    background: rgba(0, 0, 0, 0.4);
    display: flex;
    justify-content: center;
    .voiceHint-prompt {
      display: flex;
      padding: 20px;
      text-align: center;
      justify-content: center;
      align-self: center;
      cursor: pointer;
      background: $base-color;
      width: 30%;
      height: 200px;
      border-radius: 6px;
      span {
        align-self: center;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/admin/iHeritage/components/ModelManage.vue